export default __webpack_public_path__ + "static/choose-91ae026405463013a17f2928c00bd496.png";